<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="My Devices" pageTitle="Documents" />
            <DocumentsDevices />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import DocumentsDevices from '../Documents/DocumentsDevices'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'DocumentsPage',
    components: {
        MainHeader,
        PageTitle,
        DocumentsDevices,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>